import React from 'react';
import { Heart, Brain, Shield, ArrowRight } from 'lucide-react';

const LandingPage: React.FC<{ onGetStarted: () => void }> = ({ onGetStarted }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-900 to-black flex items-center justify-center p-4 sm:p-6 md:p-8">
      {/* Background Effects - Responsive scaling */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          background: 'radial-gradient(circle at 50% 50%, #3b82f6 0%, transparent 60%)',
          filter: 'blur(clamp(20px, 4vw, 40px))',
          transform: 'scale(1.2)'
        }}
      />
      
      <div className="relative w-full max-w-[90rem] mx-auto">
        {/* Content - Enhanced typography scaling */}
        <div className="space-y-6 sm:space-y-8 text-center">
          <h1 className="text-[2rem] sm:text-[2.5rem] lg:text-[3.5rem] font-bold text-white leading-[1.15] tracking-tight">
            Your AI Companion for
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400 whitespace-nowrap"> Mental Wellness</span>
          </h1>
          
          <p className="text-base sm:text-lg lg:text-xl text-gray-300 max-w-xl mx-auto leading-relaxed">
            Experience personalized mental health support powered by AI. Private, accessible, and available 24/7 to help you on your wellness journey.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 justify-center">
            <button
              onClick={onGetStarted}
              className="w-full sm:w-auto px-6 sm:px-8 py-3 sm:py-4 bg-blue-500 hover:bg-blue-600 text-white rounded-xl font-medium text-base sm:text-lg flex items-center justify-center group transition-all"
            >
              EARLY ACCESS
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
          
          {/* Feature cards - Responsive grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 pt-6 sm:pt-8">
            <div className="bg-white/5 backdrop-blur-lg rounded-xl p-4">
              <Brain className="w-6 h-6 text-blue-400 mb-2" />
              <h3 className="text-white font-medium mb-1 text-lg">AI-Powered Support</h3>
              <p className="text-gray-400 text-sm leading-relaxed">24/7 personalized mental health guidance</p>
            </div>
            
            <div className="bg-white/5 backdrop-blur-lg rounded-xl p-4">
              <Heart className="w-6 h-6 text-pink-400 mb-2" />
              <h3 className="text-white font-medium mb-1 text-lg">Evidence-Based</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Built on proven therapeutic approaches</p>
            </div>
            
            <div className="bg-white/5 backdrop-blur-lg rounded-xl p-4">
              <Shield className="w-6 h-6 text-green-400 mb-2" />
              <h3 className="text-white font-medium mb-1 text-lg">100% Private</h3>
              <p className="text-gray-400 text-sm leading-relaxed">Your data is encrypted and secure</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;